// Size chart tabs: event delegation-friendly, works with dynamically injected HTML.
// Root: .sc-tab-container
// Tabs: .sc-tab[data-tab="panel-id"]
// Panels: .sc-tab-content#panel-id

(function initSizeChartTabs() {
  document.addEventListener("click", (event) => {
    const tab = event.target.closest(".sc-tab");
    if (!tab) return;

    const root = tab.closest(".sc-tab-container");
    if (!root) return;

    // Guard: if some other script manages tabs here, optionally skip
    // (Set this attribute in your preferred initializer if needed)
    // if (root.hasAttribute("data-sc-tabs-inline")) return;

    const targetId = tab.dataset.tab;
    if (!targetId) return;

    const panel = root.querySelector(`#${CSS.escape(targetId)}`);
    if (!panel) return;

    root.querySelectorAll(".sc-tab.active").forEach((t) => t.classList.remove("active"));
    tab.classList.add("active");

    root.querySelectorAll(".sc-tab-content.active").forEach((c) => c.classList.remove("active"));
    panel.classList.add("active");
  });
})();